<template>
  <v-row no-gutters class="text-right">
    <v-col >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            x-small
            color="primaryDark"
            width="24"
            min-width="24"
            @click="$emit('onDelete')"
          >
            <v-icon size="16" color="#fff"> mdi-delete</v-icon>
          </a-btn>
        </template>
        <span>{{ $t("btnDelete") }}</span>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SignerAction",
  props: {
    upDisabled: Boolean,
    downDisabled: Boolean,
  },
};
</script>

<style>
</style>